export const WORKFLOW_STAGE_TASK_NAMES = {
	ASSESSWOUND: 'ASSESSWOUND',
	ASSIGNCASEMANAGER: 'ASSIGNCASEMANAGER',
	CODEDIAGNOSES: 'CODEDIAGNOSES',
	COMPLETEDRAFTORDER: 'COMPLETEDRAFTORDER',
	COMPLETEMISSEDVISIT: 'COMPLETEMISSEDVISIT',
	DATAENTERADVANCEDIRECTIVES: 'DATAENTERADVANCEDIRECTIVES',
	DATAENTERCONTACTS: 'DATAENTERCONTACTS',
	DATAENTERDEMOGRAPHICS: 'DATAENTERDEMOGRAPHICS',
	DATAENTERHISTORY: 'DATAENTERHISTORY',
	DATAENTERIMMUNIZATIONS: 'DATAENTERIMMUNIZATIONS',
	DATAENTERMEDICATIONPROFILE: 'DATAENTERMEDICATIONPROFILE',
	DATAENTERPATIENTADDRESSES: 'DATAENTERPATIENTADDRESSES',
	DATAENTERPATIENTINSURANCE: 'DATAENTERPATIENTINSURANCE',
	DATAENTERPATIENTPHARMACIES: 'DATAENTERPATIENTPHARMACIES',
	DATAENTERPHYSICIANS: 'DATAENTERPHYSICIANS',
	DETERMINEFACETOFACESTATUS: 'DETERMINEFACETOFACESTATUS',
	DRAWLAB: 'DRAWLAB',
	EMERGENCYPLAN: 'EMERGENCYPLAN',
	HHAVISITPLAN: 'HHAVISITPLAN',
	ASSESSHOMEBOUNDSTATUS: 'ASSESSHOMEBOUNDSTATUS',
	IDENTIFYDME: 'IDENTIFYDME',
	IDENTIFYWOUNDS: 'IDENTIFYWOUNDS',
	LABDROPOFF: 'LABDROPOFF',
	MSWDISCHARGEPLAN: 'MSWDISCHARGEPLAN',
	MSWVISITPLAN: 'MSWVISITPLAN',
	NEWFALLS: 'NEWFALLS',
	NOTIFYPHYSICIAN: 'NOTIFYPHYSICIAN',
	OTDISCHARGEPLAN: 'OTDISCHARGEPLAN',
	OTVISITPLAN: 'OTVISITPLAN',
	PLANDISCHARGE: 'PLANDISCHARGE',
	POSTCODEDIAGNOSES: 'POSTCODEDIAGNOSES',
	PRECODEDIAGNOSES: 'PRECODEDIAGNOSES',
	PTDISCHARGEPLAN: 'PTDISCHARGEPLAN',
	PTVISITPLAN: 'PTVISITPLAN',
	RESPONDTOOASISADDENDUM: 'RESPONDTOOASISADDENDUM',
	PLANOFCAREREVIEW: 'PLANOFCAREREVIEW',
	SCHEDULEFACETOFACEENCOUNTER: 'SCHEDULEFACETOFACEENCOUNTER',
	SNDISCHARGEPLAN: 'SNDISCHARGEPLAN',
	SNVISITPLAN: 'SNVISITPLAN',
	STAFFVISIT: 'STAFFVISIT',
	STDISCHARGEPLAN: 'STDISCHARGEPLAN',
	STVISITPLAN: 'STVISITPLAN',
	SUBMITNOTICEOFADMISSION: 'SUBMITNOTICEOFADMISSION',
	UPLOADFACETOFACEDOCUMENTATION: 'UPLOADFACETOFACEDOCUMENTATION',
	VERIFYADVANCEDIRECTIVES: 'VERIFYADVANCEDIRECTIVES',
	VERIFYCONTACTS: 'VERIFYCONTACTS',
	VERIFYDEMOGRAPHICS: 'VERIFYDEMOGRAPHICS',
	VERIFYHISTORY: 'VERIFYHISTORY',
	VERIFYIMMUNIZATIONS: 'VERIFYIMMUNIZATIONS',
	VERIFYPATIENTINSURANCE: 'VERIFYPATIENTINSURANCE',
	VERIFYMEDICATIONPROFILE: 'VERIFYMEDICATIONPROFILE',
	VERIFYPATIENTADDRESSES: 'VERIFYPATIENTADDRESSES',
	VERIFYPATIENTPHARMACIES: 'VERIFYPATIENTPHARMACIES',
	VERIFYPHYSICIANS: 'VERIFYPHYSICIANS',
};
